import { inject } from '@angular/core';
import type { ApolloLink, DefaultContext, TypedDocumentNode } from '@apollo/client/core';
import { Apollo } from 'apollo-angular';
import type { Observable } from 'rxjs';

/**
 * static-graphql-documents (D3): typed from the passed `TypedDocumentNode` —
 * see `mutate-create.ts` for the generic-defaults rationale.
 */
export function mutateDelete<
  TData extends object = Record<string, unknown>,
  TVariables extends { constraint?: unknown; query: unknown } = {
    constraint?: Record<string, unknown>;
    query: Record<string, unknown>;
  },
>(
  mutation: TypedDocumentNode<TData, TVariables>,
  query: TVariables['query'],
  constraint?: TVariables['constraint'],
  headers?: Record<string, string>,
): Observable<ApolloLink.Result<TData>> {
  const apollo = inject(Apollo);
  return apollo.mutate<TData, TVariables>({
    mutation,
    variables: { query, constraint } as TVariables,
    context: { headers } as DefaultContext,
  });
}
